export default "__VITE_ASSET__DYcrZEpf__"